import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oracle_colored",
  "use": "oracle_colored-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"oracle_colored\"><path fill=\"#ED1C24\" d=\"M12 4H6C3.24 4 1 6.24 1 9s2.24 5 5 5h6c2.76 0 5-2.24 5-5s-2.24-5-5-5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol